export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/cash-icon.928025bc.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};